import { Badge } from '../../../Utility/Badge';
import React from 'react';
import ToggleSwitch from '../../../Utility/ToggleSwitch';
import { DLPState } from '../../../../Types/Enums';
import TabSection from './TabSection';
import TabHeadline from './TabHeadline';
import InfoButton from '../../../Utility/InfoButton';

interface DataProtectionTabProps {
    i18n: any;
    handlePromptUpdate: any;
    prompt: any;
    localCombinedDlp: any;
}

function DataProtectionTab({ i18n, handlePromptUpdate, prompt, localCombinedDlp }: DataProtectionTabProps) {
    return (
        <div>
            <TabHeadline
                title={i18n.translate({
                    id: 'tabs.dataProtection.title',
                    sourceName: 'Prompt',
                })}
            />
            <InfoButton configKey="dataProtection" />

            <TabSection
                title={i18n.translate({
                    id: 'tabs.dlp.section.dlp.title',
                    sourceName: 'Prompt',
                })}
                subline={i18n.translate({
                    id: 'tabs.dlp.section.dlp.subtitle',
                    sourceName: 'Prompt',
                })}
            >
                <ToggleSwitch
                    options={[
                        {
                            label: i18n.translate({ id: 'dlp.on', sourceName: 'Prompt' }),
                            function: () => handlePromptUpdate({ dlp: DLPState.dlp_on }),
                            active: prompt.dlp === DLPState.dlp_on,
                        },
                        {
                            label: i18n.translate({ id: 'dlp.optional', sourceName: 'Prompt' }),
                            function: () => handlePromptUpdate({ dlp: DLPState.dlp_optional }),
                            active: prompt.dlp === DLPState.dlp_optional,
                        },
                        {
                            label: i18n.translate({ id: 'dlp.off', sourceName: 'Prompt' }),
                            function: () => handlePromptUpdate({ dlp: DLPState.dlp_off }),
                            active: prompt.dlp === DLPState.dlp_off,
                        },
                    ]}
                />

                <Badge variant="info" className="mt-6">
                    <span className="mb-0">
                        {i18n.translate({
                            id: `modelDlpHint.${prompt.modelDlp}`,
                            sourceName: 'Prompt',
                        })}
                        <br />
                        {i18n.translate({
                            id: `localCombindedDlpHint.${localCombinedDlp}`,
                            sourceName: 'Prompt',
                        })}
                    </span>
                </Badge>
            </TabSection>
        </div>
    );
}

export default DataProtectionTab;
